// extracted by mini-css-extract-plugin
export default {"Offers-container":"FilterCheckbox_Offers-container__RzblS"};